var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "service_drop_menu" }, [
    _c("div", { staticClass: "scroll_wrap" }, [
      _c(
        "div",
        { staticClass: "row_wrap" },
        [
          _c(
            "div",
            { staticClass: "col_group is_m_show" },
            [
              _c(
                "router-link-ex",
                {
                  staticClass: "service_title",
                  attrs: { to: _vm.countryPath + "/marketplace" }
                },
                [_vm._v(_vm._s(_vm.$t("service.show-all")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(
            _vm.isMobile
              ? this.swapRowColWithMaxCol(
                  _vm.marketPlaceGnbHierarchy.channelingServices,
                  5
                )
              : _vm.marketPlaceGnbHierarchy.channelingServices,
            function(column, colIdx) {
              return _vm.hasChannelingServices
                ? _c("market-place-menu-item", {
                    key: colIdx,
                    attrs: { column: column, mode: _vm.mode }
                  })
                : _vm._e()
            }
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }